import validate from 'jquery-validation';
import mask from 'jquery-mask-plugin';
import myChart from './myChart';
import carousel from 'bootstrap';
import validateStage from '../modules/sacValidateStage';

export default function simulate(params) {
  validateStage();
  const content = $('.photovoltaic__content');
  const simulate = $('.photoUni__simulate');
  const icons = $('[data-simulate="icons"]');
  const form = $('[data-form="simulate"]');
  let VR$ = $('[data-form="valueEnergy"]');
  const stateName = $('[data-simulate="stateName"]');
  const countNoKit = $('[data-simulate="countNoKit"]');
  const countKit = $('[data-simulate="countKit"]');
  const countEconomy = $('[data-simulate="countEconomy"]');
  const paybackIn = $('[data-simulate="paybackIn"]');
  const paybackThe = $('[data-simulate="paybackThe"]');
  const potency = $('[data-simulate="potency"]');
  const trees = $('[data-simulate="trees"]');
  const paybackYear = $('[data-simulate="paybackYear"]');
  const economy = $('[data-simulate="economy"]');
  const modal = $('#photovoltaic__modal');

  // VARIAVEIS UNICRED
  const parcelvSelect = $('[data-parcelv]');
  const parcelSelect = $('[data-parcel]');

  VR$.mask('000.000.000.000.000,00', {
    reverse: true
  });
  form.validate({
    errorPlacement: function (error, element) {
      return false;
    },
    submitHandler: (form) => {
      $('.modalLoader').show();
      $.ajax({
        type: "GET",
        url: $(form).attr('action'),
        data: $(form).serialize(),
        dataType: "json",
        success: (r) => {
          validateStage();
          class Calc {
            constructor(month = 1) {
              this.VR$ = $('[data-form="valueEnergy"]').val().replace(/\./g, '').replace(',', '.');
              const state = $('[data-form="state"]').val();
              stateName.text($(`[data-form="state"] option[value="${state}"]`).text());

              // VARIAVEIS DE CALCULO
              this.icms = r.icms[state];
              this.TR$ = r.tariffs[state];
              this.TR$Arr = [];
              this.VR$Arr = [];
              this.kitValue;
              this.paybackValue;
              this.potencyValue;
              // N É O MÊS
              this.n = +month;
              // CONSUMO
              this.C = [];
              // TAXA DE DISPONIBILIDADE
              this.Td;
              // HSP MÉDIO
              this.HspAVG = r.hsp[state].toFixed(1);
              // POTÊNCIA DO KIT
              this.Pkwp;
              this.potencyKit;
              // NÚMERO DE PLACAS
              this.Npl;
              // ECONOMIA MENSAL ESTIMADA
              this.E;
              this.Cs;
              this.economyTotal;
              this.economyMonth;
              this.countKitValue;
              // ÁRVORES POUPADAS
              this.A;
              // CÁLCULOS DE PAYBACK
              this.Epr;
              this.Einj;
              this.Econs;
              this.Crede;
              this.CRabatidos;
              this.CRsobra;
              this.COtotal;
              this.CRvalor;
              this.D;
              this.CRsobrar$;
              this.Vsolar;
              this.Fcaixa;
              this.Fcxacumulado = 0;
              this.FcxacumuladoArr = [];
              this.FcxacumuladoValue = [];
              this.FcxacumuladoMonth = [];
              this.Vsistema;

              // VARIAVEIS UNICRED
              this.rateMonth = 0.74;
            }

            loopTR$() {
              let valueInitial = this.TR$;
              let VRInitial = this.VR$;
              let month = 1;
              let validate = false;
              let newVR;
              for (let i = 1; i <= 300; i++) {
                if (i == month) {
                  if (validate) {
                    valueInitial *= (1.08);
                  }
                  month += 12;
                  validate = true;
                  newVR = VRInitial * valueInitial;
                }
                this.VR$Arr.push(newVR);
                this.TR$Arr.push(valueInitial);
              }
            }

            // CONSUMO
            consumption() {
              this.C = (this.VR$ / this.TR$).toFixed(2);
            }

            // TAXA DE DISPONIBILIDADE
            availabilityRate() {
              if (this.C >= 30 && this.C <= 400) {
                this.Td = 30;
              } else if (this.C >= 401 && this.C <= 600) {
                this.Td = 50;
              } else if (this.C >= 601) {
                this.Td = 100;
              }
            }

            // POTÊNCIA DO KIT
            potency() {
              this.Pkwp = Math.ceil(((this.C - this.Td) / (30.4 * .8 * this.HspAVG)) / .335 ) * .335;
              this.Pkwp = this.decimalAdjust('floor', this.Pkwp, '-2');
              this.potencyValue = this.Pkwp.toString().replace('.', ',');
              potency.text(this.potencyValue);

            }

            // NÚMERO DE PLACAS
            plates() {
              this.Npl = Math.ceil(this.Pkwp / .335);
            }

            decimalAdjust(type, value, exp) {
              // If the exp is undefined or zero...
              if (typeof exp === 'undefined' || +exp === 0) {
                return Math[type](value);
              }
              value = +value;
              exp = +exp;
              // If the value is not a number or the exp is not an integer...
              if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
                return NaN;
              }
              // Shift
              value = value.toString().split('e');
              value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
              // Shift back
              value = value.toString().split('e');
              return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
            }

            // VALOR ESTIMADO DO KIT
            async valueKit() {
              let self = this;
              let isValue = true;
              await $.each(r.valueKit.data, (index, el) => {
                if (self.Pkwp <= el.potencia && isValue) {
                  this.potencyKit = el;
                  isValue = false;
                }
              });

              if (this.potencyKit != undefined) {
                function convert(v) {
                  if (v >= 1000000) {
                    v = (v / 1000000)
                  } else if (v >= 1000) {
                    v = (v / 1000);
                  }
                  return v;
                }
                await paybackIn.text(convert(this.potencyKit.v1).toFixed(3));
                await paybackThe.text(convert(this.potencyKit.v2).toFixed(3));
                this.Vsistema = ((this.potencyKit.v1 + this.potencyKit.v2) / 2) + this.potencyKit.v_installation;
                this.kitValue = `de ${this.potencyKit.v1.toFixed(3)} a ${this.potencyKit.v2.toFixed(3)}`;
              } else {
                icons.fadeIn();
                content.fadeOut();
                if (simulate) {
                  simulate.fadeOut();
                  $('.saber-mais').removeClass('d-none');
                  $('#content-primary').addClass('d-none');
                }
                $('.saber-mais').removeClass('d-none');
                $('#content-primary').addClass('d-none');
                setTimeout(() => {
                  let targetOffset = $('#photovoltaic__project').offset().top;
                  $('html, body').animate({
                    scrollTop: targetOffset - 200
                  }, 800);
                }, 500);
                modal.addClass('ativo');
              }

            }

            // ECONOMIA MENSAL ESTIMADA
            economy() {
              this.Cs = this.Td * 1.3 * this.TR$;
              // this.E = (this.Pkwp * 30.4 * .8 * this.HspAVG * this.TR$) - (this.Td * this.TR$ * 1.05);
              this.E = parseFloat((this.VR$ - this.Cs).toFixed(2));

              this.economyMonth = (+this.E).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }, {
                maximumSignificantDigits: 2
              }).replace('R$', '');
              this.countKitValue = (this.VR$ - this.E).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }, {
                maximumSignificantDigits: 2
              }).replace('R$', '');
              countNoKit.text((+this.VR$).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }, {
                maximumSignificantDigits: 2
              }).replace('R$', ''));

              console.log(this.countKitValue);
              console.log();
              $('.saber-mais').removeClass('d-none');
              $('#content-primary').addClass('d-none');
              countKit.text(this.countKitValue);
              countEconomy.text(this.economyMonth);

              this.economyTotal = (this.E * 300).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }, {
                maximumSignificantDigits: 2
              });

              economy.text(this.economyTotal);
            }

            // ÁRVORES POUPADAS
            trees() {
              this.A = Math.round(13.1 * this.Pkwp);
              trees.text(this.A);
            }

            payback() {
              let index = 0;
              for (let month = 1; month <= 300; month++) {
                this.Epr = (this.Pkwp * 30.4 * .8 * this.HspAVG) * (Math.pow(.999256465, month));
                this.Einj = this.Epr * .3;
                this.Econs = this.Epr * .7;

                // DEFINIÇÃO Crede
                if ((this.C - this.Econs) <= 0) {
                  this.Crede = 0;
                } else {
                  this.Crede = this.C - this.Econs;
                }

                // DEFINIÇÃO CRabatidos
                if (this.Einj <= (this.Crede - this.Td)) {
                  this.CRabatidos = this.Einj;
                } else if ((this.Crede - this.Td) <= 0) {
                  this.CRabatidos = 0;
                } else {
                  this.CRabatidos = this.Crede - this.Td;
                }

                // DEFINIÇÃO CRsobra
                if (this.Einj <= (this.Crede - this.Td)) {
                  this.CRsobra = 0;
                } else {
                  this.CRsobra = this.Einj - this.CRabatidos;
                }

                this.COtotal = this.VR$Arr[month - 1];
                this.CRvalor = this.TR$Arr[index] * (1 - this.icms / 100);

                // DEFINIÇÃO D
                if ((this.Crede - this.Td) * this.CRvalor <= 0) {
                  this.D = 0;
                } else {
                  this.D = (this.Crede - this.Td) * this.CRvalor;
                }

                this.CRsobrar$ = this.CRsobra * this.CRvalor;
                this.Vsolar = this.Crede * this.TR$Arr[index] - this.D;

                // DEFINIÇÃO Fcaixa
                if (month == 1) {
                  this.Fcaixa = this.COtotal - this.Vsistema - this.Vsolar + this.CRsobrar$;
                } else {
                  this.Fcaixa = this.COtotal - this.Vsolar + this.CRsobrar$;
                }

                this.Fcxacumulado += this.Fcaixa;
                this.FcxacumuladoArr.push(this.Fcxacumulado);
                index++;
              }
            }

            loopMonth() {
              for (let i = 0; i < this.FcxacumuladoArr.length; i += 12) {
                this.FcxacumuladoValue.push(this.FcxacumuladoArr[i]);
              }
              for (let i = 1; i <= this.FcxacumuladoValue.length; i++) {
                this.FcxacumuladoMonth.push(i);
              }
              const chart = new myChart(this.FcxacumuladoValue, this.FcxacumuladoMonth);
              chart.init();
            }

            paybackYear() {
              let year = 1;

              for (let i = 0; i < this.FcxacumuladoArr.length; i++) {
                if (this.FcxacumuladoArr[i] < 0) {
                  year++;
                }
              }

              year = year / 12;
              if (!(year % 1 === 0)) {
                year = year.toFixed(1);
              }

              if (year >= 2) {
                this.paybackValue = `${year} anos`;
                if (!(year % 1 === 0)) {
                  paybackYear.text(`${year.replace('.', ',')} anos`);
                } else {
                  paybackYear.text(`${year} anos`);
                }
              } else {
                this.paybackValue = `${year} ano`;
                if (!(year % 1 === 0)) {
                  paybackYear.text(`${year.replace('.', ',')} ano`);
                } else {
                  paybackYear.text(`${year} ano`);
                }
              }
            }

            dataAjax() {
              const state = $('[data-form="state"]').val();
              const value = $('[data-form="valueEnergy"]').val();
              const name = $('[data-form="name"]').val();
              const email = $('[data-form="email"]').val();
              const phone = $('[data-form="phone"]').val();
              const token = $('input[name ="_token"]').val();

              var newsletter_check = false;
              if($('[data-form="newsletter"]').is(":checked")){
                newsletter_check = true;
              }

              $.ajax({
                type: "POST",
                url: urlSave,
                data: {
                  name: name,
                  email: email,
                  phone: phone,
                  value: value,
                  state: state,
                  newsletter: newsletter_check,
                  economyMonth: this.economyMonth,
                  valueCount: this.countKitValue,
                  investment: this.kitValue,
                  payback: this.paybackValue,
                  potency: this.potencyValue,
                  trees: this.A,
                  economyTotal: this.economyTotal,
                  _token: token
                },
                dataType: "json"
              });
            }

            scroll() {
              let targetOffset = $('#photovoltaic__content').offset().top;
              $('html, body').animate({
                scrollTop: targetOffset - 50
              }, 500);
            }

            calcParcel(parcelsNumber, pos) {
              let leftover = this.potencyKit.v2;
              let amortization = new Number((this.potencyKit.v2 / parcelsNumber).toFixed(2));
              let parcel = (this.rateMonth / 100 * leftover) + amortization;

              // ESTA PARTE COMENTADA CONTÉM O CALCULO DE TODAS AS PARCELAS
              // let parcel = [];
              // for (let i = 0; i < parcelsNumber; i++) {
              //   parcel.push((this.rateMonth / 100 * leftover) + amortization)
              //   leftover = new Number((leftover - amortization).toFixed(2));
              // }
              $(parcelvSelect[pos]).text(parcel.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }, {
                maximumSignificantDigits: 2
              }));
              if (pos < 5) {
                $(parcelSelect[pos]).text(parcelsNumber);
              }
            }

            // CALCULO PARCELAS UNICRED
            parcels() {
              let options;
              const select = $('[data-parcelselect]');
              this.calcParcel(1, 5);
              if (this.potencyKit.v2 <= 50000) {
                this.calcParcel(12, 0);
                this.calcParcel(24, 1);
                this.calcParcel(36, 2);
                this.calcParcel(48, 3);
                this.calcParcel(60, 4);
                for (let i = 1; i <= 60; i++) {
                  options += `<option value="${i}">${i}</option>`;
                }
                select.html(options);
              } else {
                this.calcParcel(24, 0);
                this.calcParcel(36, 1);
                this.calcParcel(60, 2);
                this.calcParcel(72, 3);
                this.calcParcel(120, 4);
                for (let i = 1; i <= 120; i++) {
                  options += `<option value="${i}">${i}</option>`;
                }
                select.html(options);
              }

              select.change(() => {
                this.calcParcel(select.val(), 5);
              })
            }

            async init() {
              await this.loopTR$();

              await this.consumption();
              await this.availabilityRate();
              await this.potency();
              await this.plates();
              await this.valueKit();
              if (this.potencyKit != undefined) {
                $('#carouselExampleIndicators').carousel('next');
                await this.economy();
                await this.trees();
                await this.payback();
                await this.loopMonth();
                await this.paybackYear();
                await icons.fadeOut();
                await content.fadeIn();
                await this.dataAjax();
                await this.scroll();
                if (simulate) {
                  await this.parcels();
                  await simulate.fadeIn();
                }
              }
              return this;
            }
          }

          const calc = new Calc();
          calc.init();
          $('.modalLoader').hide();
        }
      });
    }
  });

  $(function() {
        $(".estado").on('change', function() {
            $(".estado").css("background", "#e8f0fe");
        });
  });
  $(function() {
		$(".valor, .estado, .check_box, .email, .tel, .name").on('change', function() {
			if ($(this).closest('form').find('.estado').val() && $(this).closest('form').find('.valor').is(':valid') && $(this).closest('form').find('.check_box').is(':checked')) {
				$(this).closest('form').find(".simular").css({
					"display" : "block"
				});
				$(this).closest('form').find(".preencha").css({
					"display" : "none"
				});
			} else {
				$(this).closest('form').find(".simular").css({
					"display" : "none"
				});
				$(this).closest('form').find(".preencha").css({
					"display" : "block"
				});
			}
		});
	});
}
